<template>
  <div class="apply-form">
    <h1 class="form-title">{{ $cms('c_38d8c311a8b4', 'f_0001', "立即申请，成为魔筷合作基地") }}</h1>
    <div class="form-desc">
      <h2>{{ $cms('c_38d8c311a8b4', 'f_0002', "合作基地招募") }}</h2>
      <p>
        {{ $cms('c_38d8c311a8b4', 'f_0003', "请详细填写以下信息，我们会根据您的资料评估合作潜力，并安排实地考察与深度洽谈。") }}
      </p>
    </div>
    <div class="form-content">
      <el-form ref="form" :model="form" :rules="rules" :inline="false" label-position="top">
        <!-- 一、基础信息 -->
        <div class="form-section">
          <h3 class="section-title">{{ $cms('c_38d8c311a8b4', 'f_0004', "一、基础信息") }}</h3>
          
          <el-form-item class="form-item" prop="organizationName" :label="$cms('c_38d8c311a8b4', 'f_0005', &quot;1. 机构/个人名称：&quot;)">
            <el-input v-model="form.organizationName" :placeholder="$cms('c_38d8c311a8b4', 'f_0006', &quot;请输入机构/个人名称&quot;)" class="learn"></el-input>
          </el-form-item>

          <div class="row">
            <el-form-item class="form-item" prop="contactName" :label="$cms('c_38d8c311a8b4', 'f_0007', &quot;2. 联系人姓名：&quot;)">
              <el-input v-model="form.contactName" :placeholder="$cms('c_38d8c311a8b4', 'f_0008', &quot;请输入联系人姓名&quot;)" class="learn"></el-input>
            </el-form-item>
            <el-form-item class="form-item" prop="position" :label="$cms('c_38d8c311a8b4', 'f_0009', &quot;职位：&quot;)">
              <el-input v-model="form.position" :placeholder="$cms('c_38d8c311a8b4', 'f_0010', &quot;请输入职位&quot;)" class="learn"></el-input>
            </el-form-item>
          </div>

          <el-form-item class="form-item" prop="phone" :label="$cms('c_38d8c311a8b4', 'f_0011', &quot;3. 联系电话：&quot;)">
            <el-input v-model="form.phone" :placeholder="$cms('c_38d8c311a8b4', 'f_0012', &quot;请输入联系电话&quot;)" class="learn"></el-input>
          </el-form-item>

          <el-form-item class="form-item" prop="organizationType" :label="$cms('c_38d8c311a8b4', 'f_0013', &quot;4. 机构性质（单选）：&quot;)">
            <el-radio-group v-model="form.organizationType">
              <el-radio 
                v-for="option in organizationTypeOptions" 
                :key="option" 
                :label="option"
              >
                {{ option }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </div>

        <!-- 二、场地资源（核心板块） -->
        <div class="form-section">
          <h3 class="section-title">{{ $cms('c_38d8c311a8b4', 'f_0014', "二、场地资源（核心板块）") }}</h3>
          
          <el-form-item class="form-item" prop="venueAddress" :label="$cms('c_38d8c311a8b4', 'f_0015', &quot;5. 场地详细地址（省/市/区/街道）：&quot;)">
            <el-input v-model="form.venueAddress" :placeholder="$cms('c_38d8c311a8b4', 'f_0016', &quot;请输入场地详细地址&quot;)" class="learn"></el-input>
          </el-form-item>

          <el-form-item class="form-item" prop="venueTypes" :label="$cms('c_38d8c311a8b4', 'f_0017', &quot;6. 场地类型（可多选）：&quot;)">
            <el-checkbox-group v-model="form.venueTypes">
              <el-checkbox 
                v-for="option in venueTypeOptions" 
                :key="option" 
                :label="option"
              >
                {{ option }}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>

          <el-form-item class="form-item" prop="venueArea" :label="$cms('c_38d8c311a8b4', 'f_0018', &quot;7. 场地面积：&quot;)">
            <div class="area-inputs">
              <div class="area-item">
                <label>{{ $cms('c_38d8c311a8b4', 'f_0019', "总面积：") }}</label>
                <el-input v-model="form.venueArea.total" :placeholder="$cms('c_38d8c311a8b4', 'f_0020', &quot;请输入总面积&quot;)" class="area-input"></el-input>
                <span>㎡</span>
              </div>
              <div class="area-item">
                <label>{{ $cms('c_38d8c311a8b4', 'f_0021', "可合作面积：") }}</label>
                <el-input v-model="form.venueArea.available" :placeholder="$cms('c_38d8c311a8b4', 'f_0022', &quot;请输入可合作面积&quot;)" class="area-input"></el-input>
                <span>㎡</span>
              </div>
            </div>
          </el-form-item>

          <el-form-item class="form-item" prop="currentStatus" :label="$cms('c_38d8c311a8b4', 'f_0023', &quot;8. 当前使用状态：&quot;)">
            <el-radio-group v-model="form.currentStatus">
              <el-radio 
                v-for="option in currentStatusOptions" 
                :key="option.label" 
                :label="option.label"
              >
                {{ option.text }}
              </el-radio>
            </el-radio-group>
            <div v-if="form.currentStatus === $cms('c_38d8c311a8b4', 'f_0024', &quot;部分空闲&quot;)" class="partial-vacant">
              <span>{{ $cms('c_38d8c311a8b4', 'f_0025', "（可腾挪空间") }}</span>
              <el-input v-model="form.partialVacantArea" :placeholder="$cms('c_38d8c311a8b4', 'f_0026', &quot;面积&quot;)" class="number-input"></el-input>
              <span>㎡）</span>
            </div>
          </el-form-item>

          <el-form-item class="form-item" prop="venueImages" :label="$cms('c_38d8c311a8b4', 'f_0027', &quot;9. 场地实景照片/视频（请上传照片）：&quot;)">
            <file-upload 
              v-model="form.venueImages" 
              :multiple="true" 
              :max="10" 
              accept="image/*"
              @success="onUploadSuccess"
              @error="onUploadError"
            >
              <div class="up-box">{{ $cms('c_38d8c311a8b4', 'f_0028', "上传场地实景照片") }}</div>
            </file-upload>
          </el-form-item>
        </div>

        <!-- 三、本地化能力评估 -->
        <div class="form-section">
          <h3 class="section-title">{{ $cms('c_38d8c311a8b4', 'f_0029', "三、本地化能力评估") }}</h3>
          
          <el-form-item class="form-item" prop="localResources" :label="$cms('c_38d8c311a8b4', 'f_0030', &quot;11. 本地资源（可多选）：&quot;)">
            <el-checkbox-group v-model="form.localResources">
              <el-checkbox 
                v-for="option in localResourceOptions" 
                :key="option" 
                :label="option"
              >
                {{ option }}
              </el-checkbox>
            </el-checkbox-group>
            <div class="customer-group-details" v-if="form.localResources.includes($cms('c_38d8c311a8b4', 'f_0031', &quot;现有客户群体&quot;))">
              <span>{{ $cms('c_38d8c311a8b4', 'f_0032', "（约") }}</span>
              <el-input v-model="form.customerGroupSize" :placeholder="$cms('c_38d8c311a8b4', 'f_0033', &quot;人数&quot;)" class="number-input"></el-input>
              <span>{{ $cms('c_38d8c311a8b4', 'f_0034', "人）") }}</span>
            </div>
            <el-form-item prop="otherResources" :label="$cms('c_38d8c311a8b4', 'f_0035', &quot;其他&quot;)">
              <el-input v-model="form.otherResources" :placeholder="$cms('c_38d8c311a8b4', 'f_0036', &quot;请输入其他资源&quot;)" class="learn"></el-input>
            </el-form-item>
          </el-form-item>

          <el-form-item class="form-item" prop="hasTeam" :label="$cms('c_38d8c311a8b4', 'f_0037', &quot;12. 是否有可投入的人力团队？&quot;)">
            <el-radio-group v-model="form.hasTeam">
              <el-radio 
                v-for="option in hasTeamOptions" 
                :key="option.label" 
                :label="option.label"
              >
                {{ option.text }}
              </el-radio>
            </el-radio-group>
            <div v-if="form.hasTeam === $cms('c_38d8c311a8b4', 'f_0038', &quot;有&quot;)" class="team-details">
              <div class="team-info">
                <span>{{ $cms('c_38d8c311a8b4', 'f_0039', "（约") }}</span>
                <el-input v-model="form.teamSize" :placeholder="$cms('c_38d8c311a8b4', 'f_0040', &quot;人数&quot;)" class="number-input"></el-input>
                <span>{{ $cms('c_38d8c311a8b4', 'f_0041', "人，可承接岗位：") }}</span>
                <el-input v-model="form.teamRoles" :placeholder="$cms('c_38d8c311a8b4', 'f_0042', &quot;岗位&quot;)" class="role-input"></el-input>
                <span>）</span>
              </div>
            </div>
          </el-form-item>
        </div>

        <!-- 四、合作意向匹配 -->
        <div class="form-section">
          <h3 class="section-title">{{ $cms('c_38d8c311a8b4', 'f_0043', "四、合作意向匹配") }}</h3>
          
          <el-form-item class="form-item" prop="cooperationExpectations" :label="$cms('c_38d8c311a8b4', 'f_0044', &quot;13. 希望我方赋能的方面（多选）：&quot;)">
            <el-checkbox-group v-model="form.cooperationExpectations">
              <el-checkbox 
                v-for="option in cooperationExpectationOptions" 
                :key="option" 
                :label="option"
              >
                {{ option }}
              </el-checkbox>
            </el-checkbox-group>
            <el-form-item prop="otherExpectations" :label="$cms('c_38d8c311a8b4', 'f_0045', &quot;其他&quot;)">
              <el-input v-model="form.otherExpectations" :placeholder="$cms('c_38d8c311a8b4', 'f_0046', &quot;请输入其他期望&quot;)" class="learn"></el-input>
            </el-form-item>
          </el-form-item>
        </div>

        <!-- 五、补充信息 -->
        <div class="form-section">
          <h3 class="section-title">{{ $cms('c_38d8c311a8b4', 'f_0047', "五、补充信息") }}</h3>
          <el-form-item class="form-item" prop="additionalInfo" :label="$cms('c_38d8c311a8b4', 'f_0048', &quot;14. 对合作项目的其他建议或诉求：&quot;)">
            <el-input 
              v-model="form.additionalInfo" 
              type="textarea" 
              :rows="3"
:placeholder="$cms('c_38d8c311a8b4', 'f_0049', &quot;请输入其他建议或诉求&quot;)"
              class="learn"
            ></el-input>
          </el-form-item>
        </div>

        <!-- 提交说明 -->
        <div class="submit-notice">
          <h3 class="notice-title">{{ $cms('c_38d8c311a8b4', 'f_0050', "提交说明") }}</h3>
          <ul class="notice-list">
            <li>{{ $cms('c_38d8c311a8b4', 'f_0051', "● 通过初审后，我们将安排实地考察与深度洽谈。") }}</li>
            <li>{{ $cms('c_38d8c311a8b4', 'f_0052', "● 附件支持：可补充场地平面图、资质证书、周边环境照片等。") }}</li>
          </ul>
        </div>
      </el-form>
    </div>
    <div 
      class="submit-btn" 
      :class="{ 'submitting': isSubmitting }"
      @click="submitForm"
    >
      <span v-if="!isSubmitting">{{ $cms('c_38d8c311a8b4', 'f_0053', "提交申请") }}</span>
      <span v-else>{{ $cms('c_38d8c311a8b4', 'f_0054', "提交中...") }}</span>
    </div>
  </div>
</template>

<script>
import FileUpload from '@/components/FileUpload.vue';

export default {
  name: 'Type5Form',
  components: {
    FileUpload,
  },
  props: {
    isSubmitting: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        organizationName: '',
        contactName: '',
        position: '',
        phone: '',
        organizationType: '',
        venueAddress: '',
        venueTypes: [],
        venueArea: {
          total: '',
          available: ''
        },
        currentStatus: '',
        partialVacantArea: '',
        venueImages: [],
        localResources: [],
        customerGroupSize: '',
        otherResources: '',
        hasTeam: '',
        teamSize: '',
        teamRoles: '',
        cooperationExpectations: [],
        otherExpectations: '',
        additionalInfo: ''
      },
      // 选项数据
      organizationTypeOptions: [
        '企业',
        '政府/事业单位',
        '教育机构',
        '非营利组织',
        '个人业主',
        '其他'
      ],
      venueTypeOptions: [
        '园区/厂房',
        '写字楼',
        '商铺/门面',
        '仓库',
        '其他'
      ],
      currentStatusOptions: [
        { label: '完全空闲', text: '完全空闲' },
        { label: '部分空闲', text: '部分空闲' },
        { label: '正在使用', text: '正在使用（需协调）' }
      ],
      localResourceOptions: [
        '政府关系资源',
        '行业协会资源',
        '供应链/原料渠道',
        '现有客户群体',
        '物流仓储支持'
      ],
      hasTeamOptions: [
        { label: '无', text: '无（需我方派驻）' },
        { label: '有', text: '有' }
      ],
      cooperationExpectationOptions: [
        '管理模式赋能',
        '供应链支持',
        '线上渠道支持'
      ],
      rules: {
        organizationName: [
          { required: true, message: '请输入机构/个人名称', trigger: 'blur' },
        ],
        contactName: [
          { required: true, message: '请输入联系人姓名', trigger: 'blur' },
        ],
        phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        organizationType: [
          { required: true, message: '请选择机构性质', trigger: 'change' },
        ],
        venueAddress: [
          { required: true, message: '请输入场地详细地址', trigger: 'blur' },
        ],
        venueTypes: [
          { required: true, message: '请选择场地类型', trigger: 'change' },
        ],
        currentStatus: [
          { required: true, message: '请选择当前使用状态', trigger: 'change' },
        ],
        venueImages: [
          { required: true, message: '请上传场地实景照片', trigger: 'change' },
        ],
        localResources: [
          { required: true, message: '请选择本地资源', trigger: 'change' },
        ],
        hasTeam: [
          { required: true, message: '请选择是否有可投入的人力团队', trigger: 'change' },
        ],
        cooperationExpectations: [
          { required: true, message: '请选择希望我方赋能的方面', trigger: 'change' },
        ],
      }
    }
  },
  methods: {
    onUploadSuccess(url) {
      console.log('图片上传成功:', url);
      console.log('当前图片列表:', this.form.venueImages);
      this.$emit('upload-success', url);
    },

    onUploadError(error) {
      console.error('上传失败:', error);
      this.$message.error('文件上传失败');
      this.$emit('upload-error', error);
    },

    // 提交表单
    submitForm() {
      if (this.isSubmitting) {
        return; // 如果正在提交，直接返回
      }
      
      this.$refs.form.validate((valid) => {
        if (valid) {
          console.log('表单数据:', this.form);
          this.$emit('submit', this.form);
        } else {
          this.$message.error('请填写完整信息');
        }
      });
    },

    // 获取表单数据
    getFormData() {
      return this.form;
    },

    // 验证表单
    validateForm() {
      return new Promise((resolve) => {
        this.$refs.form.validate((valid) => {
          resolve(valid);
        });
      });
    }
  },
}
</script>

<style lang="less" scoped>
@import "./apply-join.less";

.form-section {
  margin-bottom: 40px;
  
  .section-title {
    font-weight: 600;
    font-size: 20px;
    color: #333333;
    line-height: 28px;
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 2px solid #DCDFE6;
  }
}

.area-inputs {
  .area-item {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    gap: 10px;
    
    label {
      min-width: 120px;
      font-weight: 500;
      color: #333;
    }
    
    .area-input {
      width: 200px;
    }
    
    span {
      color: #333;
      font-weight: 500;
    }
  }
}

.partial-vacant {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-top: 10px;
  
  .number-input {
    width: 100px;
  }
  
  span {
    color: #333;
    font-weight: 500;
  }
}

.customer-group-details {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-top: 10px;
  
  .number-input {
    width: 100px;
  }
  
  span {
    color: #333;
    font-weight: 500;
  }
}

.team-details {
  margin-top: 15px;
  
  .team-info {
    display: flex;
    align-items: center;
    gap: 5px;
    
    .number-input {
      width: 80px;
    }
    
    .role-input {
      width: 200px;
    }
    
    span {
      color: #333;
      font-weight: 500;
    }
  }
}

.submit-notice {
  margin-top: 40px;
  padding: 20px;
  background: #F8F9FA;
  border-radius: 8px;
  border-left: 4px solid #FF6600;
  
  .notice-title {
    font-weight: 600;
    font-size: 18px;
    color: #333;
    margin-bottom: 15px;
  }
  
  .notice-list {
    list-style: none;
    padding: 0;
    margin: 0;
    
    li {
      font-size: 14px;
      color: #666;
      line-height: 24px;
      margin-bottom: 8px;
      
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}

/deep/ .el-checkbox-group {
  display: flex;
  flex-wrap: wrap;
  gap: 15px 20px;
  
  .el-checkbox {
    margin-right: 0;
  }
}

/deep/ .el-radio-group {
  display: flex;
  flex-wrap: wrap;
  gap: 15px 20px;
  
  .el-radio {
    margin-right: 0;
  }
}

/deep/ .el-form-item__label {
  font-weight: 500;
  color: #333;
}

/deep/ .el-textarea__inner {
  border: 1px solid #DDDDDD;
  border-radius: 4px;
  
  &:focus {
    border-color: #FF6600;
  }
}
</style>
